/**
 * Colours for a kind of thing a person sorts by — a file's document type
 * (Contract, Receipt, COI…). Named tones, never hex: every tone is one of the
 * theme's scales, so a badge reads in dark mode as well as light.
 *
 * A type with no colour chosen in Settings still gets one of its own, picked
 * from its code, so two types side by side differ without anybody setting
 * anything — and the same type is the same colour on every screen.
 */
export const TAG_TONES = [
    { value: 'blue', label: 'Blue' },
    { value: 'green', label: 'Green' },
    { value: 'amber', label: 'Amber' },
    { value: 'red', label: 'Red' },
    { value: 'purple', label: 'Purple' },
    { value: 'teal', label: 'Teal' },
    { value: 'orange', label: 'Orange' },
    { value: 'pink', label: 'Pink' },
    { value: 'indigo', label: 'Indigo' },
    { value: 'cyan', label: 'Cyan' },
    { value: 'gray', label: 'Gray' },
];
/** The Settings choice meaning "pick one for me". */
export const AUTO_TAG_TONE = 'auto';
const TONE_VALUES = new Set(TAG_TONES.map((t) => t.value));
/** What an automatic colour is picked from: every tone but gray, which reads as "none". */
const AUTO_TONES = TAG_TONES.map((t) => t.value).filter((t) => t !== 'gray');
/** The tone a tag shows: the one chosen, else one picked from its code. */
export function tagTone(key, chosen) {
    if (typeof chosen === 'string' && TONE_VALUES.has(chosen))
        return chosen;
    let hash = 0;
    for (const ch of key.trim().toLowerCase())
        hash = (hash * 31 + ch.charCodeAt(0)) >>> 0;
    return AUTO_TONES[hash % AUTO_TONES.length];
}
//# sourceMappingURL=tagTones.js.map